export default "__VITE_ASSET__CeMcUlBB__"